import { status } from "skin/event/status";
import prd from "./product";
import { message } from "skin/event";

const add = (obj, form, story, data, d, action) => {
  const limit = data?.s?.values?.fld?.limit;
  const rows = data?.s?.values?.table?.mGoodsCategory?.count;
  if (rows >= limit) {
	message(['Добавление категории невозможно.', `Достигнут допустимый предел категорий равный ${limit}`], 'Категории и товары')
    return status.ignore;
  }
  switch (obj.table) {
    case "mProd":
      return prd(obj, form, story, data, d, action);
    default:
      return status.action;
  }
};

export default add;
